import { jsx as r, jsxs as n } from "react/jsx-runtime";
import N from "react";
import { useTranslation as k } from "react-i18next";
import { useCurrentStage as I, useCurrentForm as L } from "@perxis-auto/trade-in-sdk";
import { StageId as h } from "@perxis-auto/trade-in-sdk/types";
import { Button as s } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row as l, Col as o } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon as a } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography as g } from "@perxis-auto/ui-kit/lib/components/Typography";
import { ANALYTIC_EVENT_CALC_PRICE as y, ANALYTIC_EVENT_CONTINUE as w, BUTTON_ID_CALCULATE_COST as x, EVENT_BUTTON_CLICKED as d, ANALYTIC_EVENT_PREV_STAGE as S, BUTTON_ID_BACK as U, ANALYTIC_EVENT_FILL_MANUALLY as B, BUTTON_ID_FILL_MANUALLY as F } from "../../../shared/config/events.js";
import { useAppContext as O } from "../../../shared/lib/app/context/appContext.js";
import { sendEvent as f } from "../../../shared/lib/event/sendEvent.js";
import { Field as v } from "../../../widgets/Field/ui/Field.js";
import { Form as b } from "../../../widgets/Form/ui/Form.js";
import { GET_FORWARD_BUTTON_TEXT_MAP as R } from "../lib/config/index.js";
function Z() {
  const {
    current: t,
    data: e,
    actions: { setCurrent: m }
  } = I(), { prevStage: c } = O(), { t: i } = k(), u = L(), C = () => {
    c && (m(c.id), f(d, { id: U }, S));
  };
  if (e)
    return /* @__PURE__ */ r(b, { formId: e.form.id, schema: e.form, children: ({ isFailed: A, isDirty: E }) => {
      const p = !E && (A || !!u.error) && !!e.form.error_message;
      return /* @__PURE__ */ n(l, { gutter: [0, "vertical-yellow"], children: [
        /* @__PURE__ */ r(o, { span: 24, children: /* @__PURE__ */ n(l, { gutter: [16, "vertical-green"], children: [
          e.form.groups.map((_) => /* @__PURE__ */ r(N.Fragment, { children: _.fields.map((T) => /* @__PURE__ */ r(o, { xs: 24, sm: 12, children: /* @__PURE__ */ r(v, { fieldId: T.id, formId: e.form.id }) }, T.id)) }, _.id)),
          !!e.go_to && /* @__PURE__ */ r(o, { span: 24, children: /* @__PURE__ */ r(
            g.Link,
            {
              level: "main",
              color: "dark",
              onClick: () => {
                m(e.go_to), f(d, { id: F }, B);
              },
              children: i("stage.goTo")
            }
          ) }),
          p && /* @__PURE__ */ r(o, { span: 24, className: "pa-trade-in-error", children: /* @__PURE__ */ n(g.Paragraph, { className: "pa-trade-in-error__message", color: "light-colorful", level: "main", children: [
            /* @__PURE__ */ r(
              a,
              {
                size: 36,
                name: "warning",
                className: "pa-trade-in-error__icon",
                sticker: "trade-in-instock-warning-icon"
              }
            ),
            e.form.error_message
          ] }) })
        ] }) }),
        /* @__PURE__ */ r(o, { span: 24, children: /* @__PURE__ */ n(l, { gutter: [16, "vertical-sky"], children: [
          !!c && /* @__PURE__ */ r(o, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ r(
            s,
            {
              htmlType: "button",
              type: "ghost",
              icon: /* @__PURE__ */ r(a, { name: "back", sticker: "trade-in-instock-back-icon" }),
              iconPosition: "left",
              onClick: C,
              children: i("stage.back")
            }
          ) }),
          /* @__PURE__ */ r(o, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: p ? /* @__PURE__ */ r(
            s,
            {
              htmlType: "button",
              type: "primary",
              icon: /* @__PURE__ */ r(a, { name: "forward", sticker: "trade-in-instock-forward-icon" }),
              onClick: () => m(e.error),
              children: i("stage.forward.default")
            }
          ) : /* @__PURE__ */ r(
            s,
            {
              htmlType: "submit",
              type: "primary",
              icon: /* @__PURE__ */ r(a, { name: "forward", sticker: "trade-in-instock-forward-icon" }),
              onClick: () => {
                t && f(
                  d,
                  { id: x },
                  [h.STAGE_3, h.STAGE_4].includes(t) ? y : w
                );
              },
              children: !!t && R(t) || i("stage.forward.default")
            }
          ) })
        ] }) })
      ] });
    } }, e.form.id);
}
export {
  Z as Stage
};
